import React from 'react';

import UsersList from '../component-list-users';
import Suspense from '../../Common/components/Suspense-component';

export class UsersContainer extends React.Component {
    render() {
        return (
            <Suspense>
                <UsersList />
            </Suspense>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Users/containers/container-list-users.js